var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g-vue-table',{ref:"deletableVueTable",attrs:{"apiIndexUrl":'/api/attributes/'+_vm.attribute,"sortBy":"name","columns":_vm.columns,"actionsDropdown":_vm.actionsDropdown},on:{"newObj":function($event){return _vm.$emit('newObj')}}})}
var staticRenderFns = []

export { render, staticRenderFns }